import React from 'react';
import { Box, BoxProps, Text } from 'rebass';
import { StatusStyle } from './StatusDot';

type StatusChipProps = BoxProps & {
  status?: StatusStyle;
};

const StatusChip = ({
  status = 'default',
  ...props
}: StatusChipProps): JSX.Element => {
  const variantString = `chip${
    status.charAt(0).toUpperCase() + status.slice(1)
  }`;

  return (
    <Box my={-1} flexShrink={0} {...(props as any)} variant={variantString}>
      <Text variant="body2" fontSize={props.fontSize} color="inherit">
        {props.children}
      </Text>
    </Box>
  );
};

export default StatusChip;
